import { render, staticRenderFns } from "./ResultTabs.vue?vue&type=template&id=277e09b6&scoped=true&"
import script from "./ResultTabs.vue?vue&type=script&lang=js&"
export * from "./ResultTabs.vue?vue&type=script&lang=js&"
import style0 from "./ResultTabs.vue?vue&type=style&index=0&id=277e09b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e09b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
